import {cloneDeep} from 'lodash';
import {getString} from "Core/helpers/data";
import {AsyncDownloadCheckListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {AsyncDownloadCheckListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new AsyncDownloadCheckListItemDataObject(
		getString(result, 'exportRequestId'),
		getString(result, 'exportType'),
		getString(result, 'status'),
		getString(result, 'exportFileName'),
	);

	return result;
}